import { apiClient } from '@/libs/api'
import { type AreaExEntity } from '@/libs/api'

export type FetchAreaQuery = {
  tenantKey: string
  areaId: number
}

export const fetchArea = async (
  { tenantKey, areaId }: FetchAreaQuery,
  signal?: AbortSignal
): Promise<AreaExEntity> => {
  const { data } = await apiClient._tenant(tenantKey).areas._id(areaId).$get({
    config: { signal }
  })
  return data
}
